$(document).ready(function () {
// 

  // Menu

//   $(".header-wrapper nav ul li a").click(function () {
//     $(".menu-drawer-container").removeClass("menu-opening");
// 	$("html").removeClass("overflow-hidden");
//   });

//    $(".menu-drawer-container .header__icon span").click(function () {
//     $("html").toggleClass("overflow-hidden");
//   });

// When nav link is clicked → close menu + remove overflow
//   $(".header-wrapper nav ul li a").click(function () {
//     $(".menu-drawer-container").removeClass("menu-opening");
//     $("html").removeClass("overflow-hidden");
//   });

//   // When burger/close icon is clicked → toggle both menu and overflow
//   $(".menu-drawer-container .header__icon span").click(function () {
//     $(".menu-drawer-container").toggleClass("menu-opening");

//     if ($(".menu-drawer-container").hasClass("menu-opening")) {
//       $("html").addClass("overflow-hidden");
//     } else {
//       $("html").removeClass("overflow-hidden");
//     }
//   });

// $(".jm-mfp-close").click(function () {
//     // $(".menu-drawer-container").removeClass("menu-opening");
//     $("html").addClass("overflow-hide");
//   });

// Popup OPEN (when popup is active)
// $(document).on('click', '.jm-popup-open', function () {
// //   $('body').addClass('jm-popup-active');
// //   $('html').addClass('jm-html-locked');
// });

// Popup CLOSE
$(document).on('click', '.jm-mfp-close', function (e) {
  e.preventDefault();

  $('body').addClass('jm-popup-closed');
});


  function toggleHtmlOverflow() {
    if ($('cart-drawer.drawer').hasClass('active')) {
      $('html').addClass('cart-drawer-open');
    } else {
      $('html').removeClass('cart-drawer-open');
    }
  }

  // Run on page load
  toggleHtmlOverflow();

 

// Observe class changes (for dynamic open/close)
  const cartDrawerEl = document.querySelector('cart-drawer.drawer');
  if (cartDrawerEl) {
    const observer = new MutationObserver(toggleHtmlOverflow);
    observer.observe(cartDrawerEl, {
      attributes: true,
      attributeFilter: ['class']
    });
  }


  // Click on nav link: close menu + remove overflow
  $(".header-wrapper nav ul li a").click(function () {
    $(".menu-drawer-container").removeClass("menu-opening");
    $("html").removeClass("overflow-hidden");
  });

  // Click on menu icon: toggle both together
  $(".menu-drawer-container .header__icon span").click(function () {
    const $menuDrawer = $(".menu-drawer-container");

    if ($menuDrawer.hasClass("menu-opening")) {
      // If already open → close it
      $menuDrawer.removeClass("menu-opening");
      $("html").removeClass("overflow-hidden");
    } else {
      // If closed → open it
      $menuDrawer.addClass("menu-opening");
      $("html").addClass("overflow-hidden");
    }
  });


AOS.init({
      // ... your other initialisation options here ...
      once: true,
    });

// Fancy Box Start
Fancybox.bind("[data-fancybox]", {
	Thumbs: {
      autoStart: true, // Show thumbnails automatically
    },
});
// Fancy Box Start

$('.carouselTicker-one').carouselTicker({
        speed: 2,
        // mode: "vertical",
        direction: "next",
        pauseOnHover: false,
}); 

  $(window).scroll(function () {
		if ($(this).scrollTop() > 50) {
			$('.header-wrapper').addClass('fixed');
		} else {
			$('.header-wrapper').removeClass('fixed');
		}
	});

  // $(window).scroll(function () {
	// 	if ($(this).scrollTop() > 10) {
	// 		$('.about-us-section').addClass('fixed');
	// 	} else {
	// 		$('.about-us-section').removeClass('fixed');
	// 	}
	// });


  /* Responsive Tabing Start */
	(function ($) {

		$(document).on('shown.bs.tab', '.nav-tabs-responsive [data-bs-toggle="tab"]', function(e) {
			var $target = $(e.target);
			var $tabs = $target.closest('.nav-tabs-responsive');
			var $current = $target.closest('li');
			var $next = $current.next();
			var $prev = $current.prev();
	
			$tabs.find('>li').removeClass('next prev active');
			$prev.addClass('prev');
			$next.addClass('next');
			$next.removeClass('active');
			$prev.removeClass('active');
			$current.addClass('active');
		});

	})(jQuery);
	/* Responsive Tabing End */

	// // slider
	// $(".design-block").slick({
	// 	dots: false,
	// 	arrows: true,
	// 	slidesToShow: 6,
	// 	slidesToScroll: 1,
	// 	prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12" fill="none"><path d="M7 1L2 6L7 11" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M22.5 6H2" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></div>',
	// 	nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="12" viewBox="0 0 23 12" fill="none"><path d="M16.5 1L21.5 6L16.5 11" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M1 6H21.5" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></div>',
	// 	appendArrows: $('.design-block-arrows-container'),
	// 	variableWidth: true,
	// 	responsive: [
	// 		{
	// 			breakpoint: 1200,
	// 			settings: {
	// 				slidesToShow: 3,
	// 			}
	// 		},
	// 	]
	// });
	// // slider

  // var speed = 6000;
	// $(".design-block").slick({
	// 	dots: false,
	// 	arrows: true,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	variableWidth: false,
	// 	autoplay: true,
  // // autoplaySpeed: 5000,
  // autoplaySpeed: speed,
	// 	prevArrow:
	// 		'<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12" fill="none"><path d="M6.75 1L1.75 6L6.75 11" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M22.25 6H1.75" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></div>',
	// 	nextArrow:
	// 		'<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="13" viewBox="0 0 24 13" fill="none"><path d="M17.25 1.5957L22.25 6.5957L17.25 11.5957" stroke="#591D16" stroke-width="2" stroke-linecap="round"/><path d="M1.75 6.5957H22.25" stroke="#591D16" stroke-width="2" stroke-linecap="round"/></svg></div>',
	// 	appendArrows: $(".design-block-arrows-container"),
	// 	responsive: [
	// 		{ breakpoint: 1400, settings: { slidesToShow: 1 } },
	// 		{ breakpoint: 1200, settings: { slidesToShow: 1 } },
	// 		{ breakpoint: 992, settings: { slidesToShow: 1 } },
	// 		{ breakpoint: 768, settings: { slidesToShow: 1 } },
	// 		{ breakpoint: 576, settings: { slidesToShow: 1 } },
	// 	],
	// });
	
  $('.design-section').each(function () {
  var $section = $(this);
  var speed = parseInt($section.data('slider-speed'), 10) || 6000;

  var $slider = $section.find('.design-block');

  if (!$slider.length) return;

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: speed,
    prevArrow:
      '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12" fill="none"><path d="M6.75 1L1.75 6L6.75 11" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M22.25 6H1.75" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></div>',
    nextArrow:
      '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="13" viewBox="0 0 24 13" fill="none"><path d="M17.25 1.5957L22.25 6.5957L17.25 11.5957" stroke="#591D16" stroke-width="2" stroke-linecap="round"/><path d="M1.75 6.5957H22.25" stroke="#591D16" stroke-width="2" stroke-linecap="round"/></svg></div>',
    appendArrows: $section.find('.design-block-arrows-container')
  });
});


	$(".collection-slider").slick({
		dots: false,
		arrows: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		variableWidth: false,
		prevArrow:
			'<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12" fill="none"><path d="M7 1L2 6L7 11" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M22.5 6H2" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></div>',
		nextArrow:
			'<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="12" viewBox="0 0 23 12" fill="none"><path d="M16.5 1L21.5 6L16.5 11" stroke="white" stroke-width="2" stroke-linecap="round"/><path d="M1 6H21.5" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></div>',
		appendArrows: $(".collection-slider-arrows-container"),
		responsive: [
			{ breakpoint: 1400, settings: { slidesToShow: 2 } },
			{ breakpoint: 1024, settings: { slidesToShow: 1 } },
			{ breakpoint: 750, settings: { slidesToShow: 2 } },
			{ breakpoint: 480, settings: { slidesToShow: 1 } },
		],
	});

	// faq js
	 // When any accordion <summary> is clicked
  $(".accordion details summary").on("click", function (e) {
    const $current = $(this).parent(); // current <details> element

    // Close all other open accordions
    $(".accordion details").not($current).removeAttr("open");

    // Allow the current one to toggle normally (Shopify handles its open/close)
  });
  // faq js


	/*$.scrollIt({
		upKey: 38,             // key code to navigate to the next section
		downKey: 40,           // key code to navigate to the previous section
		easing: 'linear',      // the easing function for animation
		scrollTime: 600,       // how long (in ms) the animation takes
		activeClass: 'active', // class given to the active nav element
		onPageChange: null,    // function(pageIndex) that is called when page is changed
		topOffset: 200           // offste (in px) for fixed top navigation
	});*/
 
 
// In ScrollIt Page Add This Script For Redirect Page And scrollTo Section
/*const queryString = window.location.hash.substr(1);
  // console.log(queryString);
  if(queryString != ''){
    $('.hideclick').attr('data-scroll-goto', queryString);
    setTimeout(function (){
      $('.hideclick').click();
     
    }, 600);
}*/
	

 
  // OFI Browser
  objectFitImages();


});
 

// ensure GSAP ScrollTrigger plugin is registered
    // gsap.registerPlugin(ScrollTrigger);

    // // select the horizontal container
    // let horizontalSection = document.querySelector('.about-us-block');

    // // (optional) log scrollWidth for debug
    // console.log('horizontal scrollWidth:', horizontalSection.scrollWidth);

    // // animate horizontal translation as the user scrolls vertically
    // gsap.to('.about-us-block', {
    //   x: () => horizontalSection.scrollWidth * -1,
    //   xPercent: 100,
    //   scrollTrigger: {
    //     trigger: '.about-us-block',
    //     start: 'center center',
    //     end: '+=2000px',
    //     pin: '#horizontal-scoll',
    //     scrub: true,
    //     invalidateOnRefresh: true
    //   }
    // });

	gsap.registerPlugin(ScrollTrigger);

// GSAP matchMedia for responsive control
ScrollTrigger.matchMedia({
  "(min-width: 1200px)": function () {
    let horizontalSection = document.querySelector(".about-us-block");
    if (!horizontalSection) return;

    console.log("horizontal scrollWidth:", horizontalSection.scrollWidth);

    gsap.to(".about-us-block", {
      x: () => horizontalSection.scrollWidth * -1,
      xPercent: 100,
      scrollTrigger: {
        trigger: ".about-us-block",
        start: "center 60%",
        end: "+=2500px",
        pin: "#horizontal-scoll",
        scrub: true,
        invalidateOnRefresh: true
      }
    });
  }
});

// gsap.registerPlugin(ScrollTrigger);

// ScrollTrigger.matchMedia({
//   "(min-width: 1200px)": function () {
//     const horizontalSection = document.querySelector(".about-us-block");
//     const header = document.querySelector("header"); // ← your sticky header
//     const headerHeight = header.offsetHeight;

//     gsap.to(horizontalSection, {
//       x: () => horizontalSection.scrollWidth * -1,
//       xPercent: 100,
//       scrollTrigger: {
//         trigger: horizontalSection,
//         start: () => `center+=${headerHeight} center`,
//         end: "+=2000",
//         pin: "#horizontal-scoll",
//         scrub: true,
//         invalidateOnRefresh: true
//       }
//     });
//   }
// });


	
// 	// loader start

//    document.addEventListener("DOMContentLoaded", function () {
//     const loader = document.getElementById("page-loader");
 
//     // Check if loader has already been shown in this session
//     if (!sessionStorage.getItem("loaderShown")) {
//       // Show loader
//       loader.style.display = "flex";
 
//       // Hide loader after 2 seconds
//       setTimeout(() => {
//         loader.style.display = "none";
//         sessionStorage.setItem("loaderShown", "true");
//       }, 2000);
//     } else {
//       // Hide loader immediately
//       if (loader) loader.style.display = "none";
//     }
//   });
// 	// loader end


// document.addEventListener('click', function (e) {
//   const closeBtn = e.target.closest('.jm-mfp-close');
//   if (!closeBtn) return;

//   e.preventDefault(); // stop page jump

//   document.body.classList.add('jm-popup-closed');
// });


// document.addEventListener('click', function (e) {
//   if (e.target.closest('.jm-mfp-close')) {
//     e.preventDefault();
//     document.body.classList.add('jm-popup-closed');
//   }
// });
